/*
 * @Author: Teemo Ding
 * @Date: 2022-04-19 16:32:16
 * @LastEditTime: 2022-04-20 17:07:18
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/pages/Settings/Permissions/Components/CheckboxTree/index.tsx
 */
import { Checkbox } from 'antd';
import { get } from 'lodash';
import React from 'react';
import { useI18n } from 'src/hooks/useRouterChange';
import { i18nGet } from 'src/tools/tools';
import css from './css.module.less';

const CheckboxGroup = Checkbox.Group;

const TextI18nKeyMapping = {
  ['Analyst']: 'usersAndPermissions.detail.analyst',
  ['Administrator']: 'usersAndPermissions.detail.administrator',
  ['Finance']: 'usersAndPermissions.detail.finance',
  ['Sales assistant (access to own and related sales)']:
    'usersAndPermissions.detail.salesassistant(accesstoownandrelatedsales)',
  ['Publisher']: 'usersAndPermissions.detail.publisher',
  ['CustomerSupport']: 'usersAndPermissions.detail.customerSupport',
  ['Sales manager (access to all orders)']:
    'usersAndPermissions.detail.salesmanager(accesstoallorders)',
  ['Fulfillment']: 'usersAndPermissions.detail.fulfillment',
  ['Viewer']: 'usersAndPermissions.detail.viewer',
};
const CheckboxTree = (props) => {
  const i18n = useI18n();
  const getI18n = (str) => i18nGet(i18n, str);

  const { value, onChange, checkAllText, disabled } = props;
  const plainOptions = (value || []).map((item) => {
    return {
      label: getI18n(TextI18nKeyMapping[get(item, 'role.name')]),
      value: get(item, 'role.name'),
    };
  });
  const checkedList = (value || [])
    .filter((o) => o.checked)
    .map((item) => get(item, 'role.name'));

  const indeterminate =
    !!checkedList.length && checkedList.length !== plainOptions.length;
  const checkAll =
    !!checkedList.length && checkedList.length === plainOptions.length;

  const onCheckboxChange = (list) => {
    const allValue = value.map((item) => ({
      ...item,
      checked: list.includes(get(item, 'role.name')),
    }));
    onChange(allValue);
  };

  const onCheckAllChange = (e) => {
    const allValue = value.map((item) => ({
      ...item,
      checked: e.target.checked,
    }));
    onChange(allValue);
  };
  return (
    <div>
      <Checkbox
        indeterminate={indeterminate}
        onChange={onCheckAllChange}
        className={css.checkAll}
        disabled={disabled}
        checked={checkAll}>
        {checkAllText || getI18n('usersAndPermissions.detail.checkall')}
      </Checkbox>
      <CheckboxGroup
        options={plainOptions}
        value={checkedList}
        disabled={disabled}
        className={css.checkboxGroup}
        onChange={onCheckboxChange}
      />
    </div>
  );
};

export default CheckboxTree;
